import styled from 'styled-components';

export const FullscreenOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;
